export default {"src":"/_next/static/media/lock.578154c3.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};